/**
 * About Page Component
 * Static information page about the brand.
 */

'use client';

import styled from '@emotion/styled';

const PageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.space['3xl']} ${({ theme }) => theme.space.md};
`;

const Title = styled.h1`
  font-size: ${({ theme }) => theme.typography.variants.heading1.fontSize}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
  margin: 0 0 ${({ theme }) => theme.space.xl};
`;

const Subtitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.variants.heading3.fontSize}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.demi};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: ${({ theme }) => theme.space['2xl']} 0 ${({ theme }) => theme.space.md};
`;

const Paragraph = styled.p`
  font-size: ${({ theme }) => theme.typography.variants['body-regular'].fontSize}px;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.8;
  margin: 0 0 ${({ theme }) => theme.space.lg};
`;

const HeroImage = styled.div`
  width: 100%;
  aspect-ratio: 16 / 7;
  border-radius: ${({ theme }) => theme.radius.regular};
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.space['2xl']};
  background: linear-gradient(135deg, #f8d7d3 0%, #f5c6c0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeroText = styled.span`
  font-size: 3rem;
  font-weight: ${({ theme }) => theme.typography.config.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  opacity: 0.3;
`;

export function AboutPage() {
  return (
    <PageContainer>
      <Title>About Shapermint</Title>

      <HeroImage>
        <HeroText>Shapermint</HeroText>
      </HeroImage>

      <Paragraph>
        Shapermint is on a mission to help every woman feel confident and
        comfortable in her own skin. We believe that shapewear should empower,
        not restrict — and that every body deserves to feel amazing.
      </Paragraph>

      <Subtitle>Our Story</Subtitle>
      <Paragraph>
        Founded with the simple idea that shapewear could be better, Shapermint
        has grown into a community of over 5 million women who share our vision
        of comfort, confidence, and self-love. We work tirelessly to create
        products that combine innovative design with everyday wearability.
      </Paragraph>

      <Subtitle>Our Promise</Subtitle>
      <Paragraph>
        Every Shapermint product is designed with you in mind. From our
        wireless shaping bras to our seamless leggings, we use premium
        materials and thoughtful construction to deliver shapewear you'll
        actually want to wear — all day, every day.
      </Paragraph>

      <Subtitle>Join the Movement</Subtitle>
      <Paragraph>
        We're more than a brand — we're a movement. Join millions of women
        around the world who have discovered the Shapermint difference.
        Because feeling great should never be a compromise.
      </Paragraph>
    </PageContainer>
  );
}
